import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import messages from '../modules/messages';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    reducer: state => ({
//      params: state.params,
    }),
  })],
  modules: {
    messages,
  },
});
